var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 2.35901C4.88447 2.35901 2.35889 4.88459 2.35889 8.00004C2.35889 11.1155 4.88447 13.6411 7.99992 13.6411C11.1154 13.6411 13.6409 11.1155 13.6409 8.00004C13.6409 4.88459 11.1154 2.35901 7.99992 2.35901ZM1.33325 8.00004C1.33325 4.31814 4.31802 1.33337 7.99992 1.33337C11.6818 1.33337 14.6666 4.31814 14.6666 8.00004C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00004ZM7.4871 5.265C7.4871 4.98177 7.7167 4.75218 7.99992 4.75218H8.00676C8.28998 4.75218 8.51958 4.98177 8.51958 5.265C8.51958 5.54822 8.28998 5.77782 8.00676 5.77782H7.99992C7.7167 5.77782 7.4871 5.54822 7.4871 5.265ZM6.80334 8.00004C6.80334 7.71682 7.03293 7.48722 7.31616 7.48722H7.99992C8.28314 7.48722 8.51274 7.71682 8.51274 8.00004V10.2223H8.68368C8.9669 10.2223 9.1965 10.4519 9.1965 10.7351C9.1965 11.0183 8.9669 11.2479 8.68368 11.2479H7.99992C7.7167 11.2479 7.4871 11.0183 7.4871 10.7351V8.51286H7.31616C7.03293 8.51286 6.80334 8.28326 6.80334 8.00004Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleRed);
export default __webpack_public_path__ + "static/media/info-circle-red.14ebb1bd54349159d9932333b69a016e.svg";
export { ForwardRef as ReactComponent };